/**
 * @module "behavior/answer.form.behavior"
 * @description This file contains code for the AnswerFormBehavior.
 * @property {object} defaults - defaults form to null.
 *
 * @todo This could use more documentation
 */

define('formkit/behavior/answer.form.root.behavior',['require','exports','module','marionette','./bind.registered.view.events.behavior','./register.view.behavior','./inline.validations.behavior'],function(require, exports, module) {
  //prettier-ignore
  var Mn                               = require('marionette'),
      BindRegisteredViewEventsBehavior = require('./bind.registered.view.events.behavior'),
      RegisterViewBehavior             = require('./register.view.behavior'),
      InlineValidationsBehavior        = require('./inline.validations.behavior');

  /**
   * @class AnswerFormBehavior
   */

  var AnswerFormBehavior = Mn.Behavior.extend({
    defaults: {
      form: null,
    },

    behaviors: function() {
      return {
        /**
         * @implements BindRegisteredViewEventsBehavior
         * @see {@link behavior/bind.registered.view.events.behavior.js}
         */
        BindRegisteredViewEventsBehavior: {
          form: this.getOption('form'),
          name: 'showAllFailedValidationsButtonView',
          viewEvents: {
            press: 'showAllFailedValidationsOnActiveSection',
          },
          behaviorClass: BindRegisteredViewEventsBehavior,
        },

        /**
         * @implements RegisterViewBehavior
         * @see {@link behavior/register.view.behavior.js}
         */
        RegisterViewBehavior: {
          form: this.getOption('form'),
          name: 'formBasicAnswerView',
          behaviorClass: RegisterViewBehavior,
        },

        /**
         * @implements InlineValidationsBehavior
         * @see {@link behavior/inline.validations.behavior.js}
         */
        InlineValidationsBehavior: {
          form: this.getOption('form'),
          validationMode: 'inline',
          behaviorClass: InlineValidationsBehavior,
        },
      };
    },
  });
  module.exports = AnswerFormBehavior;
});

